import { render, staticRenderFns } from "./PreviewDocument.vue?vue&type=template&id=21f4125d&scoped=true"
import script from "./PreviewDocument.vue?vue&type=script&lang=ts"
export * from "./PreviewDocument.vue?vue&type=script&lang=ts"
import style0 from "./PreviewDocument.vue?vue&type=style&index=0&id=21f4125d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f4125d",
  null
  
)

export default component.exports